import { Controller } from "stimulus"

export default class extends Controller {
  closeModal(event) {
    this.element.remove();
  }
}